module.exports = __webpack_public_path__ + "static/media/hair (62).3c60b4c1.jpg";